
import BoxCategoryNewComponent from "../../../components/box_categories/New.vue";

export default {
  components: {
    BoxCategoryNewComponent
  }
};
